import { render, staticRenderFns } from "./SummaryMessageBox.vue?vue&type=template&id=32d7e680&scoped=true&"
import script from "./SummaryMessageBox.vue?vue&type=script&lang=js&"
export * from "./SummaryMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMessageBox.vue?vue&type=style&index=0&id=32d7e680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7e680",
  null
  
)

export default component.exports